import {
	WeaTools
} from 'ecCom';

export const readRecord = (params) => {
	return WeaTools.callApi('/api/hrm/payroll/readRecord', 'GET', params);
}

export const confirmRecord = (params) => {
	return WeaTools.callApi('/api/hrm/payroll/confirmRecord', 'POST', params);
}

export const feedback = (params) => {
	return WeaTools.callApi('/api/hrm/payroll/feedback', 'POST', params);
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/apis/payrollDetail.js